import { VHeaders } from '@/models/pagedlistmodel';

export function getFaxListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('fax.faxGrid.from') as string,
      align: 'left',
      value: 'messageJson.from',
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : 'Unknown';
        },
      ],
    },
    {
      text: vm.$parent.$t('fax.faxGrid.to') as string,
      align: 'left',
      value: 'messageJson.to',
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : 'Unknown';
        },
      ],
    },
    {
      text: vm.$parent.$t('fax.faxGrid.dateTime') as string,
      align: 'left',
      value: 'createdAt',
      sortable: true,
      fieldType: 'date',
    },
    {
      text: vm.$parent.$t('fax.faxGrid.status') as string,
      align: 'left',
      value: 'messageJson.status',
      sortable: true,
    },
    {
      text: vm.$parent.$t('fax.faxGrid.actions') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getExistingMessageHeaders(vm: any): VHeaders[] {
  return [

        {
            text: vm.$parent.$t('sendAppointmentMessage.sendAppointmentGrid.date') as string,
            sortable: true,
            align: 'center',
            value: 'createdAt',
            fieldType: 'date',
        },
        {
            text: vm.$parent.$t('sendAppointmentMessage.sendAppointmentGrid.from') as string,
            sortable: true,
            align: 'center',
            value: 'messageJson.from',
        },
        {
            text: vm.$parent.$t('sendAppointmentMessage.sendAppointmentGrid.to') as string,
            sortable: true,
            align: 'center',
            value: 'messageJson.to',
        },
        {
            text: vm.$parent.$t('sendAppointmentMessage.sendAppointmentGrid.message') as string,
            sortable: true,
            align: 'center',
            value: 'messageJson.textJson.body',
        },
        {
            text: vm.$parent.$t('sendAppointmentMessage.sendAppointmentGrid.status') as string,
            sortable: true,
            align: 'center',
            value: 'messageJson.status',
        },
    ];
}
